import { useTranslation } from 'react-i18next';

function useRouteHelper() {
  const { t, i18n } = useTranslation(['routes']);
  const lang = i18n.language;
  function setRoute(route: string, params: { [key: string]: string | number } = {}, language = lang) {
    // get localized url
    const localizedRoute = t(route);
    // create an array of subpaths
    const path = localizedRoute.split('/');
    const parsedPath = path.map((subpath) => {
      if (params && subpath.charAt(0) === ':') {
        // get the actual param by removing ':' and '?' if present
        // and return its value
        const paramKey = subpath.split(':')[1].split('?')[0];
        return params[paramKey];
      }
      // if no params provided return as is
      // (with react-router dynamic params not replaced)
      return subpath;
    });
    return [`/${language}`, ...parsedPath].filter((item) => Boolean(item)).join('/');
  }
  function getRoute(route: string) {
    return [`/${lang}`, t(route)].join('');
  }
  return {
    setRoute,
    getRoute,
  };
}

export { useRouteHelper };
